module.exports = __webpack_public_path__ + "img/img_userCase4.056ec582.png";